export const formatPercentage = number => {
  return Intl.NumberFormat("pt-BR", {
    style: "percent",
    maximumFractionDigits: 2
  }).format(Number(number) / 100);
};

export const formatDate = date => new Date(date).toLocaleDateString("pt-BR");
